<!--
 * @Author: 直播专区
 * @Date: 2020-07-27 10:30:48
 * @LastEditors: ymk
 * @LastEditTime: 2020-07-27 13:53:18
 * @FilePath: \car-demo\src\components\Live.vue
-->
<template>
  <div style="padding: 0 14px;">
    <div class="live-area" style="margin-bottom: 10px;box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.08);">

      <iframe :src="index_data.live_link ?  index_data.live_link : 'http://www.baidu.com'" frameborder="0" width="100%" height="100%"></iframe>

      <!-- <p class="title">{{index_data.live_title}}</p>
      <div class="block">
        <span v-if="timeData" class="text">
          距直播开启时间：<span class="trans">{{ timeData.hour }}</span> 时
          <span class="trans">{{ timeData.minute }}</span
          >分 <span class="trans">{{ timeData.second }}</span> 秒</span
        >
      </div> -->
    </div>
  </div>

</template>

<script>
    import dayjs from 'dayjs'
    import countDown from '../utils/countDown'



    export default {
        name: 'live-area',
        props: {
            src: String,
            // 废弃
            state: [String, Number],
            url: String, // 可能是视频地址，也可能是网页地址
            endTime: String, // 直播结束时间
            index_data:{},
            //index_data.live_link 就是直播地址 ，ifram 产品说啥的
        },

        data: () => ({
            timeData: null,
        }),
        computed: {
            style() {
                if (this.poster) {
                }
            },
            duration() {
                // if (!this.endTime) return
                let start_time = dayjs()
                let end_time = dayjs().add(1, 'year')
                return end_time.diff(start_time, 'second')
            },
        },
        mounted() {
            this.updateCountDown()
        },
        methods: {
            updateCountDown() {
                // if (!this.endTime || this.duration <= 0) return
                let timer = new countDown(this.duration, 3).start()
                timer.on('change', (value) => {
                    this.timeData = value
                })
            },
        },
    }


</script>

<style lang="less" scoped>
	.live-area {
		padding: 0 14px;
		.title {
			color: rgba(51, 51, 51, 1);
			font-size: 15px;
			font-weight: bold;
			margin-bottom: 10px;
		}

		.block {
			position: relative;
			display: flex;
			justify-content: center;
			align-items: center;
			height: 180px;
			font-size: 15px;
			color: #fff;
			background-color: #000;
			background-image: url('https://dss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=3468842248,1928586949&fm=26&gp=0.jpg');
			background-size: cover;
			background-repeat: no-repeat;
			&::before {
				content: '';
				position: absolute;
				left: 0;
				top: 0;
				z-index: 1;
				width: 100%;
				height: 100%;
				background-color: rgba(0, 0, 0, 0.3);
			}

			.text {
				position: relative;
				z-index: 2;
			}
			.trans {
				display: inline-block;
				background-color: rgba(255, 255, 255, 0.3);
				color: #fff;
				padding: 0 3px;
				border-radius: 3px;
			}
		}
	}
</style>
